/**
 * The credit-note lookup refuses with a code as its message (409); the cashier
 * reads a sentence instead (CU2-008). Any other message is already readable.
 */
const CREDIT_NOTE_LOOKUP_MSG: Record<string, string> = {
  CREDIT_NOTE_ALREADY_USED:
    'This credit note has already been used in full. Choose another payment method.',
  CREDIT_NOTE_EXPIRED: 'This credit note has expired. Choose another payment method.',
};

export function creditNoteLookupMessage(message: string): string {
  return CREDIT_NOTE_LOOKUP_MSG[message] ?? message;
}
